"use client";
import * as React from "react";
const SvgForestOutlined = ({
  title,
  titleId,
  ...props
}) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 16 14", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { fill: "currentColor", d: "M16 11.2 13.43 7h1.24L10 0 8 3 6 0 1.33 7h1.24L0 11.2h4.67V14h2.66v-2.8h1.34V14h2.66v-2.8zm-6-8.76 2.1 3.16H11l2.57 4.2h-2.41L9.43 7h1.24L8.8 4.22zM2.44 9.8l2.57-4.2H3.9L6 2.44 8.1 5.6H7l2.57 4.2z" }));
export {
  SvgForestOutlined as default
};
